import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aba3cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "staff-list h-full w-11 py-3 bg-white flex flex-column align-items-center",
  style: {"max-height":"60vh"}
}
const _hoisted_2 = { class: "staff-list-header w-full px-4 pt-2 flex align-items-center justify-content-between lg:flex-row md:flex-row sm:flex-column-reverse px-3 pb-4" }
const _hoisted_3 = { class: "lg:w-6 md:w-6 sm:w-full flex lg:justify-content-start md:justify-content-start sm:justify-content-between lg:pt-0 md:pt-0 sm:pt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1" }, "すべて選択", -1))
const _hoisted_5 = { class: "lg:ml-3 md:ml-3 sm:ml-0" }
const _hoisted_6 = { class: "lg:w-6 md:w-6 sm:w-full flex align-items-center relative cursor-pointer lg:pl-3 md:pl-3 sm:pl-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search absolute ml-3" }, null, -1))
const _hoisted_8 = { class: "w-full mt-2 flex flex-wrap overflow-auto" }
const _hoisted_9 = { class: "ml-1" }

import { get, set } from "@vueuse/core";
import { ref, watch, watchEffect, computed } from "vue";
import { IStaff } from "@/clinic/typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffList',
  props: {
    staffs: null,
    autoDistributionIds: null
  },
  emits: ["updateDistributedStaffs"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  staffs: IStaff[];
  autoDistributionIds: number[];
};

const selectAll = ref(false);
const searchInput = ref();


const autoDistributions = ref<number[]>([]);
const staffList = ref<IStaff[]>([]);



const debounce = (fn: (...args: any[]) => void, delay: number) => {
  const timeoutId = ref<number | null>(null);

  return (...args: any[]) => {
    if (timeoutId.value !== null) {
      clearTimeout(timeoutId.value);
    }
    timeoutId.value = window.setTimeout(() => fn(...args), delay);
  };
};
const performSearch = debounce((newValue: any) => {
  search(newValue);
}, 300);
const search = (value: string) => {
  if (value) {
    const staffs = props.staffs.filter((staff: IStaff) => staff.name_kanji.toLowerCase().includes(value.toLowerCase()));
    set(staffList, staffs);
  }
};

const onSelectAll = () => {
  if (selectAll.value) {
    const staffIds = props.staffs.map((staff: IStaff) => staff.id);
    set(autoDistributions, staffIds);
  } else {
    set(autoDistributions, []);
  }
};

watch(searchInput, newValue => {
  performSearch(newValue);
});

watch(autoDistributions, newValue => {
  emits("updateDistributedStaffs", newValue);
  if (newValue.length === props.staffs.length) set(selectAll, true);
  else set(selectAll, false);
});

watchEffect(() => {
  set(autoDistributions, props.autoDistributionIds);
  if (!get(searchInput)) set(staffList, props.staffs);
});

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_component_Checkbox, {
            modelValue: selectAll.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
            binary: true,
            onChange: onSelectAll
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, "選択された: " + _toDisplayString(autoDistributions.value.length), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_InputText, {
          modelValue: searchInput.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
          placeholder: "名前",
          style: {"padding-left":"3rem"}
        }, null, 8, ["modelValue"]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffList.value, (staff) => {
        return (_openBlock(), _createElementBlock("div", {
          key: staff.id,
          class: "py-2 px-4 flex align-items-center lg:w-4 md:w-6 sm:w-12"
        }, [
          _createVNode(_component_Checkbox, {
            class: "mr-2",
            value: staff.id,
            name: "auto_distribution",
            modelValue: autoDistributions.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((autoDistributions).value = $event)),
            inputId: `auto-distribution-${staff.id}`
          }, null, 8, ["value", "modelValue", "inputId"]),
          (staff.avatar?.url)
            ? (_openBlock(), _createBlock(_component_Avatar, {
                key: 0,
                image: staff.avatar.url,
                shape: "circle",
                class: "flex-shrink-0 mr-1"
              }, null, 8, ["image"]))
            : (_openBlock(), _createBlock(_component_Avatar, {
                key: 1,
                icon: "pi pi-user",
                shape: "circle",
                class: "flex-shrink-0 mr-1"
              })),
          _createElementVNode("label", _hoisted_9, _toDisplayString(staff.name_kanji), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})